import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PartnerStateService } from '../../../partner/services/partner-state.service';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';

@Component({
  selector: 'app-kiosk-order-registration',
  templateUrl: './kiosk-order-registration.component.html',
  styleUrls: ['./kiosk-order-registration.component.css']
})
export class KioskOrderRegistrationComponent implements OnInit {

  @ViewChild('partnerRegistrationForm') partnerRegistrationForm;

  constructor(
    private router: Router,
    private partnerStateService: PartnerStateService,
    private kioskStateService: KioskStateService,
  ) { }

  ngOnInit() {
    this.partnerRegistrationForm.showPassword = false;
  }

  onBack() {
    this.kioskStateService.update(KioskStateEnum.LoginOrRegister);
  }

  onRegister() {
    this.partnerStateService.createPartner(
      this.partnerRegistrationForm.partner,
      this.partnerRegistrationForm.password.password
    ).subscribe(
      result => {
        if (result) {
          this.kioskStateService.update(KioskStateEnum.CreateOrder);
        } else {
          this.partnerRegistrationForm.error = 'Registration failed. Please try again later';
        }
      },
      (error) => {
        this.partnerRegistrationForm.error = error.message;
      }
    );
  }

}
